import axiosInstance from "../../../core/api/axios";
import {ILesson} from "../models/lesson";
import { viewContent } from "../../../core/queries/accessControl";

export async function getLessonDetails(slug: string, isFree: boolean): Promise<ILesson> {
  try {
    const response = await axiosInstance.get(`/lessons/${slug}`)

    if(isFree) {
      await viewContent(slug, response.data.id, 'lesson')
    }

    return response.data;
  } catch (e: any) {
    console.log(e)
    throw new Error(e);
  }
}
